<template>
  <body :class="{ debug: isDev, update: isUpdate }">
    <header>
      <b-navbar toggleable="md" type="light" variant="light" id="top-bar">
        <b-navbar-brand to="/">
          <img src="/static/images/logo-horizontal-h53.png" alt="">
        </b-navbar-brand>

        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-collapse is-nav id="nav_collapse">

          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown :text="i18n.lang" right>
              <b-dropdown-item @click="$i18n.locale = 'en'">English</b-dropdown-item>
              <b-dropdown-item @click="$i18n.locale = 'bg'">Български</b-dropdown-item>
            </b-nav-item-dropdown>
            <template v-if="user">
              <b-nav-item-dropdown :text="user.name" right>
                <b-dropdown-item to="/change">{{$t("Change Password")}}</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item @click="logout">{{$t("Logout")}}</b-nav-item>
            </template>
          </b-navbar-nav>

        </b-collapse>

      </b-navbar>
    </header>

    <router-view></router-view>

    <footer class="text-center">
      <img src="/static/images/logo-horizontal-h53.png" alt="Blockchain.bg">
    </footer>

  </body>
</template>

<script>
export default {
  data() {
    return {
      i18n: {
        lang: this.$t('lang'),
      },
      isDev: process.env.APP_DEBUG,
      isUpdate: process.env.APP_UPDATE,
      buildTimestamp: process.env.BUILD_TIMESTAMP,
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
  },
  computed: {
    user() {
      return this.$store.getters.getLoggedUser
    },
  },
  watch: {
    '$i18n.locale': function() {
      this.i18n.lang = this.$t('lang')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/App.vue